/**
 * Resolve a checklist photo/signature value to something an <img> can render.
 *
 * Backwards compatible with legacy check-lists that stored base64 data URLs
 * directly in Mongo — those come back as `data:image/...` and we return them
 * as-is. New check-lists store the bytes in object storage; we get a relative
 * `/api/uploads/{id}` URL that needs the backend origin + an `?auth` query
 * param because <img> tags cannot send Authorization headers.
 */
export function checklistImageSrc(value, token) {
  if (!value) return "";
  if (typeof value !== "string") return "";
  if (value.startsWith("data:")) return value;
  const backend = process.env.REACT_APP_BACKEND_URL || "";
  if (value.startsWith("/api/")) {
    const sep = value.includes("?") ? "&" : "?";
    const auth = token ? `${sep}auth=${encodeURIComponent(token)}` : "";
    return `${backend}${value}${auth}`;
  }
  if (value.startsWith("http")) return value;
  return value;
}
